import type { ReactNode } from 'react';
import useOrganisationFeatureFlag, {
  type OrganisationFeatureFlag,
} from 'app/hooks/useOrganisationFeatureFlag';
import useUserRoles from 'app/hooks/useUserRoles';
import FeatureDisabledState from './FeatureDisabledState';

interface FeatureGuardProps {
  flag: OrganisationFeatureFlag;
  children: ReactNode;
}

export default function FeatureGuard({ flag, children }: FeatureGuardProps): JSX.Element {
  const enabled = useOrganisationFeatureFlag(flag);
  const { isSupport } = useUserRoles();
  if (!enabled && !isSupport) return <FeatureDisabledState />;
  return <>{children}</>;
}
